(function () {
  if (window.__nurseryPremiumGalleryBound) return;
  window.__nurseryPremiumGalleryBound = true;

  function swapMainImage(thumb) {
    var root = thumb.closest('[data-np-gallery]');
    var main = root && root.querySelector('.np-main-image');
    var nextUrl = thumb.dataset.npImage;

    if (!main || !nextUrl) return;

    var picture = main.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (source) {
        source.removeAttribute('srcset');
        source.removeAttribute('sizes');
      });
    }

    main.srcset = '';
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = nextUrl;
    main.setAttribute('src', nextUrl);
    main.alt = thumb.dataset.npAlt || '';

    root.querySelectorAll('[data-np-image]').forEach(function (item) {
      var active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
  }

  function handleGalleryClick(event) {
    var thumb = event.target.closest('[data-np-image]');
    if (!thumb) return;
    event.preventDefault();
    swapMainImage(thumb);
  }

  function handleVariantChange(event) {
    var select = event.target.closest('[data-np-variant]');
    if (!select) return;

    var root = select.closest('[data-np-product-root]');
    var option = select.options[select.selectedIndex];
    var price = root && root.querySelector('[data-np-price]');
    var button = root && root.querySelector('[data-np-submit]');

    if (price) price.textContent = option.dataset.price || '';
    if (button) button.disabled = option.dataset.available !== 'true';
  }

  document.addEventListener('click', handleGalleryClick);
  document.addEventListener('change', handleVariantChange);
})();
